module.exports = __webpack_public_path__ + "b0ceb6c06376415d70ea604c16652007.pdf";